/* eslint-disable sort-keys-fix/sort-keys-fix */
// Benzinga Edge May/June Install Soft/Hard Mobile/Desktop Cold/Warm/Hot Traffic

const standardButton = 'JOIN NOW & SAVE 43%';
const coldListItems = [
  [
    'Premium content & expert insights',
    'Real-time alerts on your portfolio',
    'Exclusive intel on insider trades',
    '5 hidden-gem stocks every Friday',
    'Our top 10 stocks (updated daily)',
  ],
  [
    'Premium content & expert insights',
    'Real-time market crash alerts',
    'Insider sell-offs before headlines hit',
    'A daily risk check on your portfolio',
    '5 weekly stock ideas for any market',
  ],
];

const warmListItems = [
  [
    'Spot breakout plays early',
    'Profit alongside D.C. insiders ',
    'Get the real story on your stocks',
    'Move fast on breaking news',
    'Build a winning portfolio in less time',
  ],
  [
    'Avoid costly false breakout traps',
    'Expose hidden portfolio risks',
    'Move before bad news hits prices',
    'Generate income in any market',
    'Protect your retirement now',
  ],
];

type SophiPaywallCopy = {
  id: string;
  title?: string;
  subTitle?: string;
  htmlTitle?: string;
  listHeading?: string;
  listButtons?: string[];
  listItems?: string[];
  button: string;
  buttonMobile?: string;
};

interface SophiPaywallCopyMap {
  [key: string]: SophiPaywallCopy;
}

export const sophiPaywallCopyMap: SophiPaywallCopyMap = {
  'ct-pw1': {
    id: 'ct-pw1',
    title: 'This Article Requires A Benzinga Edge Subscription',
    listHeading: 'MEMBERS UNLOCK:',
    listItems: coldListItems[0],
    button: standardButton,
  },
  'ct-pw1-o': {
    id: 'ct-pw1-o',
    title: 'This Article Requires A Benzinga Edge Subscription',
    listHeading: 'MEMBERS UNLOCK:',
    listItems: coldListItems[0],
    button: standardButton,
  },
  'ct-pw2': {
    id: 'ct-pw2',
    title: "YOU'RE OUT OF FREE ARTICLES!",
    listHeading: 'Become A Benzinga Edge Member Now to Unlock:',
    listItems: coldListItems[0],
    button: standardButton,
  },
  'ct-pw3': {
    id: 'ct-pw3',
    title: 'This Article Requires A Benzinga Edge Subscription',
    listHeading: 'MEMBERS UNLOCK:',
    listItems: coldListItems[1],
    button: standardButton,
  },
  'ct-pw4': {
    id: 'ct-pw4',
    title: "YOU'RE OUT OF FREE ARTICLES!",
    listHeading: 'Become A Benzinga Edge Member Now to Unlock:',
    listItems: coldListItems[1],
    button: standardButton,
  },
  'wt-pw5': {
    id: 'wt-pw5',
    title: 'Get the Investing Essentials',
    subTitle: 'ALL IN ONE PLACE',
    listHeading: 'EVERYTHING YOU NEED TO:',
    listItems: warmListItems[0],
    button: standardButton,
  },
  'wt-pw6': {
    id: 'wt-pw6',
    htmlTitle: `
      <div class='hidden md:block font-bold text-[30px] leading-[36px]'>Stop Reading About Profits </br> Start Making Them With <em>Benzinga Edge</em></div>
      <div class="block md:hidden text-[24px] font-bold leading-[28px]">Unlock Your </br> Complete Investing </br> Command Center</div>
    `,
    listHeading: 'EVERYTHING YOU NEED TO:',
    listItems: warmListItems[0],
    button: standardButton,
  },
  'wt-pw7': {
    id: 'wt-pw7',
    title: 'Everything You Need to Beat the Market',
    subTitle: 'Unlock Expert Stock Picks, Pro-Grade Tools, and Real-Time Portfolio Alerts -All In One Place',
    listItems: [
      'Cut through the market noise',
      'Stay one step ahead of mayhem',
      'Track what Wall Street insiders are buying',
      'Find ways to potentially profit no matter boom or bust',
    ],
    button: 'GET YOUR EDGE - SAVE 43%',
  },
  'wt-pw8': {
    id: 'wt-pw8',
    title: 'Get the Investing Essentials',
    subTitle: 'ALL IN ONE PLACE',
    listHeading: 'BENZINGA EDGE IS EVERYTHING YOU NEED TO:',
    listItems: warmListItems[1],
    button: standardButton,
  },
  'wt-pw9': {
    id: 'wt-pw9',
    htmlTitle: `
      <div class='hidden md:block font-bold text-[30px] leading-[36px]'>Stop Reading About Retirement </br> Start Protecting It With <em>Benzinga Edge</em></div>
      <div class="block md:hidden text-[24px] font-bold leading-[28px]">Unlock Your </br> Complete Investing </br> Command Center</div>
    `,
    subTitle: '',
    listHeading: 'EVERYTHING YOU NEED TO:',
    listItems: warmListItems[1],
    button: standardButton,
  },
  'wt-pw10': {
    id: 'wt-pw10',
    title: 'Everything You Need to Protect Your Retirement',
    subTitle: 'Unlock Expert Stock Picks, Pro-Grade Tools, And Real-Time Portfolio Alerts -All In One Place',
    listHeading: 'EVERYTHING YOU NEED TO:',
    listItems: [
      'Expose ticking time bombs in your portfolio ',
      'Act fast before bad news tanks prices',
      'Generate potential income in any market',
      'Stay one step ahead through crashes, corrections, and chaos',
    ],
    button: 'JOIN BENZINGA EDGE & SAVE 43%',
    buttonMobile: 'GET YOUR EDGE  - SAVE 43%',
  },
  'ht-pw11': {
    id: 'ht-pw11',
    htmlTitle: 'CLAIM YOUR <div class="bg-bzblue-700 text-white px-2 rounded-md">43%</div> NEW-MEMBER DISCOUNT',
    listHeading: 'Become A Benzinga Edge Member to Unlock:',
    listItems: [
      'Real-time breaking alerts on your portfolio',
      'A suite of pro-grade trading tools',
      '5 hidden gem picks every Friday',
      'One-click performance ranking on any stock',
      'Top 10 stocks leaderboards (updated daily)',
    ],
    button: 'CLAIM THIS SPECIAL OFFER  - SAVE 43% NOW',
    buttonMobile: 'CLAIM THIS SPECIAL OFFER',
  },
  'ht-pw12': {
    id: 'ht-pw12',
    title: 'SPECIAL OFFER',
    subTitle: 'UNLOCKED',
    listHeading: 'save 43% on  Benzinga Edge:',
    listButtons: ['Normal Price: $19/month', 'Your Price: $10.75/month'],
    listItems: [
      'Real-time Portfolio Alerts',
      'Pro-grade trading tools',
      'Daily Stock Ideas',
      'Edge Instant Stock Rankings',
      'Top Stocks Leaderboards',
      '3 Premium Research Reports',
    ],
    button: 'CLAIM THIS SPECIAL OFFER  - SAVE 43% NOW',
    buttonMobile: 'CLAIM NEW MEMBER DISCOUNT',
  },
  spw1: {
    id: 'spw1',
    title: "You're Almost Out of Free Articles!",
    subTitle: 'Become a Benzinga Edge Member Now to Unlock:',
    listItems: [
      'All premium content &  insights',
      'Real-time alerts on your portfolio',
      'Exclusive intel on insider trades',
      '5 hidden-gem stocks every Friday',
      'Top 10 stocks leaderboards (updated daily)',
    ],
    button: 'JOIN NOW & SAVE 43%',
  },
};

export const EdgeLogoSvg = ({ fill = '#192940' }: { fill?: string }) => (
  <svg fill="none" height="16px" viewBox="0 0 121 12" width="121px" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.779 11.507H20.9103V9.4106H15.2436V6.83853H19.9388V4.74211H15.2436V2.36383H20.9462V0.26741H12.779V11.507ZM30.6966 7.34942L25.3717 0.26741H21.7018L22.8531 1.69438V11.5422H25.2997V4.16075L30.8045 11.507H33.1611V0.26741H30.6966V7.34942ZM9.07316 5.72866C10.1525 5.53487 11.052 4.54833 11.052 3.15659C11.052 1.65915 9.93666 0.26741 7.72395 0.26741H0.600098L1.71545 1.65915V11.5246H7.9758C10.1885 11.5246 11.3398 10.1681 11.3398 8.4769C11.2859 7.08516 10.3144 5.88721 9.07316 5.72866ZM4.16202 2.38144H7.23823C8.06575 2.38144 8.58744 2.8571 8.58744 3.56178C8.58744 4.26645 8.06575 4.74211 7.23823 4.74211H4.16202V2.38144ZM7.34617 9.42822H4.16202V6.83853H7.34617C8.28162 6.83853 8.80332 7.41989 8.80332 8.12456C8.80332 8.93494 8.24564 9.4106 7.34617 9.42822ZM69.1042 7.34942H70.3814V8.67069C69.7158 9.1992 68.8883 9.49868 68.0248 9.5163C65.974 9.5163 64.5349 7.98363 64.5349 5.92245C64.5349 3.86126 65.992 2.32859 68.0248 2.32859C69.0862 2.32859 70.0756 2.87472 70.6513 3.75556L72.5942 2.69855C71.7666 1.41251 70.3095 0.26741 68.0068 0.26741C64.7507 0.26741 62.0523 2.46953 62.0523 5.88721C62.0523 9.3049 64.7147 11.507 68.0068 11.507C69.8058 11.5422 71.5148 10.7847 72.7021 9.48107V5.32347H67.4492L69.1042 7.34942ZM58.0406 7.34942L52.6977 0.26741H49.0459L50.1792 1.69438V11.5422H52.6438V4.16075L58.1486 11.507H60.4872V0.26741H58.0406V7.34942ZM80.8333 0.26741H76.1021L77.2354 1.69438L77.0376 2.24051L73.3677 11.5422H76.1381L76.8577 9.63962H81.8048L82.5244 11.5422H85.2948L80.8333 0.26741ZM77.4873 7.52559L79.2863 2.68093L81.0852 7.52559H77.4873ZM45.1601 0.26741H47.6247V11.5599H45.1601V0.26741ZM43.1993 2.20527V0.26741H34.5463V2.36383H39.9792L34.5463 9.58677V11.507H43.2892V9.4106H37.7305L43.1993 2.20527Z"
      fill={fill}
    />
    <path d="M84.1641 0.267441H120.3V11.5599H88.6811L84.1641 0.267441Z" fill="#3F83F8" />
    <path
      d="M116.035 9.20183H111.39L112.837 2.63855H117.481L117.206 3.83903H113.968L113.663 5.26583H116.832L116.566 6.46631H113.388L113.053 7.99151H116.291L116.035 9.20183Z"
      fill="white"
    />
    <path
      d="M104.621 6.37568C104.621 4.16168 106.293 2.52824 108.567 2.52824C109.964 2.52824 110.869 3.28592 111.273 4.12232L109.983 4.67336C109.747 4.13216 109.098 3.76808 108.37 3.76808C107.15 3.76808 106.077 4.85048 106.077 6.28712C106.077 7.28096 106.776 8.078 107.927 8.078C108.488 8.078 108.921 7.86152 109.255 7.57616L109.423 6.77912H108.726L107.947 5.57864H111.086L110.515 8.11736C109.875 8.87504 108.931 9.31784 107.848 9.31784C106.057 9.31784 104.621 8.18624 104.621 6.37568Z"
      fill="white"
    />
    <path
      d="M98.6882 2.63855H101.227C102.683 2.63855 104.071 3.76031 104.071 5.46263C104.071 7.18463 102.9 9.20183 99.8198 9.20183H97.2417L98.6882 2.63855ZM98.9145 7.97183H100.076C101.66 7.97183 102.614 6.85991 102.614 5.55119C102.614 4.59671 101.935 3.86855 100.961 3.86855H99.8198L98.9145 7.97183Z"
      fill="white"
    />
    <path
      d="M96.1514 9.20183H91.5068L92.9533 2.63855H97.5979L97.3224 3.83903H94.085L93.7799 5.26583H96.9484L96.6827 6.46631H93.5044L93.1698 7.99151H96.4072L96.1514 9.20183Z"
      fill="white"
    />
  </svg>
);
